import { createSelector } from 'reselect';

const selectUserDeleteSkillButtonState = state => state.UserDeleteSkillButton;

export const selectIsDeletingUserSkill = createSelector(
  selectUserDeleteSkillButtonState,
  (state, props) => state.deleting
);
